import React, { HTMLAttributes } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import INewsArticle from "apiConsumers/newsApiConsumer/models/INewsArticle";
import routes from "routes";
import RouterLink from "components/links/RouterLink";
import TextBoxWithImage from "components/textBoxes/textboxWithImage/TextBoxWithImage";
import calculateAspectRatio from "utils/calculateAspectRatio";
import imageSizes from "imageSizes";
import clsx from "clsx";
import { cssImportant, newsItemHoverOpacity } from "theme";

const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        root: { display: "flex", flex: "1" },
    });
});

const useTextBoxWithImageStyles = makeStyles((theme: Theme) => {
    return createStyles({
        root: {
            flex: "1",
            "&:hover": {
                opacity: newsItemHoverOpacity,
            },
        },
        titleContainer: {
            flex: "1",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        descriptionContainer: { flex: "0" + cssImportant },
    });
});

interface IProps extends HTMLAttributes<HTMLElement> {
    isLoading?: boolean;
    article?: INewsArticle;
}

export default function SubArticleWithTitle(props: IProps) {
    const classes = useStyles();
    const textBoxWithImageClasses = useTextBoxWithImageStyles();

    const { className, isLoading = false, article = {}, ...rest } = props;

    const { featureImage = {}, title, url } = article;
    const { url: featureImageSrc = "" } = featureImage;

    const { route } = routes.news;

    return (
        <RouterLink
            className={clsx(className, classes.root)}
            to={typeof url === "undefined" ? route : `${route}/${url}`}
            style={{ textDecoration: "none" }}
            {...rest}
        >
            <TextBoxWithImage
                classes={{
                    root: textBoxWithImageClasses.root,
                    titleContainer: textBoxWithImageClasses.titleContainer,
                    descriptionContainer: textBoxWithImageClasses.descriptionContainer,
                }}
                heading={title}
                imageProps={{
                    aspectRatio: calculateAspectRatio(imageSizes.newsArticle),
                    src: featureImageSrc,
                    isLoading: isLoading,
                }}
                mobile
            />
        </RouterLink>
    );
}
